<template>
  <div class="customer-info-content">
    <div class="customer-info">
      <div class="name">
        <div>{{ customer.name }}</div>
        <div class="customer-info-qr" @click="openQrcode()">
          <a-icon type="qrcode" />{{ $t('page_ops_customer_fault_reporting_qr_code') }}
        </div>
      </div>
      <a-row class="customer-info-detail">
        <a-col :span="8">
          {{ $t('page_ops_customer_contacts') }}： <span class="value">{{ customer.contact }}</span>
        </a-col>
        <a-col :span="8">
          {{ $t('page_ops_customer_contact_info') }}：<span class="value">{{ customer.tel }}</span>
        </a-col>
        <a-col :span="8" style="text-overflow: ellipsis;overflow-x: hidden;white-space: nowrap">
          {{ $t('page_ops_customer_contact_address') }}：
          <span class="value">
            {{ address }}
          </span>
        </a-col>
      </a-row>
    </div>
    <div class="footer-wapper flex-1 flex">
      <div class="left-wapper">
        <div ref="scrollPanel" class="scroll-panel">
          <div>
            <div style="margin-bottom: 6px;">
              <a-button v-acl="'page_ops_create_custom_device'" type="primary" style="margin-right: 4px;" @click="showCreateDevice">
                {{ $t('page_ops_create_custom_device') }}
              </a-button>
              <span v-acl="'page_ops_import_custom_device'">
                <import-button
                  filename= '自定义设备模板.xlsx'
                  :downloadFn="exportFn"
                  :importFn="importFn"
                  :newResFlag=true
                  @refresh="()=>getCustomDevice(filter.customerId)"
                  style="margin-right: 4px"
                />
              </span>
              <a-button v-acl="'page_ops_customer_device_sharing'" :disabled="canShare" @click="handleMove">
                {{ $t('page_ops_customer_device_sharing') }}
              </a-button>
            </div>
            <a-select
              show-search
              optionFilterProp="children"
              v-model="deviceTypeCode"
              style="width: 49%; margin-right: 4px"
              @change="handleChange"
            >
              <a-select-option
                v-for="(item, index) in deviceTypes"
                :key="index"
                :value="item.key"
                >{{ item.value }}</a-select-option
              >
            </a-select>
            <a-select
              v-model="deviceStatus"
              show-search
              optionFilterProp="children"
              style="width: 49%;"
              @change="handleChangeStatus"
            >
              <a-select-option
                v-for="(item, index) in deviceStatu"
                :key="index"
                :value="item.key"
                >{{ item.value }}</a-select-option
              >
            </a-select>
          </div>
          <div class="name"  v-if="machineList.length > 0">{{$t('page_ops_system_device')}}</div>
            <div
              v-if="machineList.length > 0"
              class="list-panel scroll"
              infinite-scroll-distance="10"
              :infinite-scroll-immediate="false"
            >
              <div
                v-for="(machine, index) in machineList"
                :key="index"
                class="panel-wapper"
                :class="{
                  selected: machine.id === currentMachine.id
                }"
                @click="changeMachine(machine)"
              >
                <div v-if="machine.isShared" class="tag">
                  {{ $t('page_ops_customer_share') }}
                </div>
                <div class="pic">
                  <img :src="getDeviceImg(machine.avatar, machine.name,imgListMap)" />
                </div>
                <a-tooltip style="color: #333333;" class="ellipsis" :title="machine.name">{{
                  machine.name.length> 10? machine.name.slice(0,9)+ '...' : machine.name
                }}</a-tooltip>
                <div>
                  (<a-tooltip class="code ellipsis" :title="machine.serialNo">{{
                    machine.serialNo
                  }}</a-tooltip
                  >)
                </div>
              </div>
            </div>
          <template v-if="customDeviceList.length>0">
            <div class="name">{{$t('page_ops_custom_device')}}</div>
              <div
                class="list-panel scroll"
                infinite-scroll-distance="10"
                :infinite-scroll-immediate="false"
              >
                <div v-for="item in customDeviceList" :key="item.id" style="display: flex; flex-wrap: wrap;">
                  <div  class="panel-wapper" style="width:180px; background-color: #f3f4f5; border-radius: 4px;text-align: center;padding: 10px 0;cursor: default;">
                    <div style="color: #333333;" class="ellipsis">{{item.deviceName}}</div>
                    <div class="code ellipsis">({{item.deviceCode}})</div>
                    <div style="display: flex;align-items: center;justify-content: center;">
                      <div style="color: #3a7fbc;cursor: pointer;" v-acl="'page_ops_edit_custom_device'" @click="editCustomDevice(item)">{{$t('edit')}}</div>
                      <div style="margin: 0 10px;">|</div>
                      <div style="color: #ff4d4f;cursor: pointer;" v-acl="'page_ops_delete_custom_device'" @click="deleteCustomDevice(item)">{{$t('delete')}}</div>
                    </div>
                  </div>
                </div>
              </div>
          </template>
        </div>
      </div>
      <device-detail
        :device="currentMachine"
        :statusData="statusData"
        @refreshStatus="refreshStatus"
        class="flex-1"
      ></device-detail>

      <move-machine
        :visible="moveVisible"
        :customerId="customerId"
        @cancel="moveCancel"
        :loading="moveLoading"
        @ok="(value, unValue) => moveOk(value, unValue)"
      ></move-machine>
    </div>
    <createCustomDevice
      v-if="customDeviceDialog"
      :visible="customDeviceDialog"
      :form="customDeviceItem"
      :typeList="deviceTypeList"
      @cancel="customDeviceCancel"
      @ok="updateCustomDevice"
    />
    <a-modal :visible="visible"  v-if="visible" title="" :closable="false" centered  style="z-index:5000">
      <div style="margin-bottom: 16px;">
        <a-icon type="close-circle" style="color: red;font-size: 22px; margin-right: 16px;" />
        <span style="font-size: 16px;">{{$t('tips')}}</span>
      </div>
      <div v-if="customerList && customerList.length > 0">
        <span v-for="(customer,index) in customerList" :key="index">
          <a @click="toggleCustomer(customer.customerId)">
            <span>{{customer.customerName}}&nbsp;</span>
            <span v-if="index < customerList.length - 1">,</span>
          </a>
        </span>
        <span>已存在相同序列号的系统设备或自定义设备</span>
      </div>
      <div v-if="showTip" style="margin-top:20px">未出库机床已存在相同序列号的系统设备</div>
      <template slot="footer">
        <a-button type="primary" @click="customerDeviceOk">
          {{ $t('ok') }}
        </a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import DeviceDetail from './DeviceDetail'
import MoveMachine from './MoveMachine'
import mixin from './mixin'
import { CustomerServiceProxy } from '@/service-proxies/app-v2/client.service-proxies'
import { MachineServiceProxy,CustomMachineServiceProxy,DeviceTypeServiceProxy } from '@/service-proxies/app-v2/workStation.service-proxies'
import { StatisticsServiceProxy } from '@/service-proxies/app-v2/mdc.service-proxies'
import dayjs from 'dayjs'
import createCustomDevice from './createCustomDevice';
import { Modal } from 'ant-design-vue';
import ImportButton from '@/components/ImportButton/index.vue'
import moment from 'moment';
import { exportCustomDeviceTemplate, importCustomDevice } from "@/api/api";
import { DictBizServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import { getDeviceImg } from '../utils/index'

const stsp = new StatisticsServiceProxy()
const msp = new MachineServiceProxy()
const cmps = new CustomMachineServiceProxy();
const dtsp = new DeviceTypeServiceProxy();
const csp = new CustomerServiceProxy()
const dictBizServiceProxy = new DictBizServiceProxy()
export default {
  name: 'CreateCustomer',
  components: {
    DeviceDetail,
    MoveMachine,
    createCustomDevice,
    ImportButton
  },
  props: {
    customerId: {
      type: String,
      default: ''
    },
    deviceStatu: {
      type: Array,
      default: () => []
    },
    deviceTypes: {
      type: Array,
      default: () => []
    }
  },
  mixins: [mixin],
  computed: {
    canShare() {
      return !(this.customer && this.customer.relatedTenantId)
    },
    address(){
      if(this.customer.provinceName){

        if(this.customer.provinceName === this.customer.cityName){
          return `${this.customer.provinceName}-${this.customer.address}`
        }
        return `${this.customer.provinceName}-${this.customer.cityName}-${this.customer.address}`
      }else{
        return '';
      }
    }
  },
  data() {
    return {
      customer: {},
      machineList: [], // 设备列表
      loadText: this.$t('page_ops_customer_loading'), // 设备列表外层无限加载组件加载时的提示文字
      currentMachine: {},
      deviceTypeCode: 0,
      deviceStatus: '0',
      filter: {
        customerId: '',
        isAssigned: true,
        assemblyState: '',
        deviceTypeId: ''
      },
      statusData: {},
      moveVisible: false,
      moveLoading: false,

      // 自定义设备
      customDeviceList: [],
      // 设备类型
      deviceTypeList: [],
      customDeviceDialog: false,  // 弹框
      customDeviceItem: {
        id: '',
        deviceName: '',
        deviceCode: '',
        deviceTypeId: '',
        customerId: ''
      },
      visible:false,
      customerList: [],
      showTip:false,
      tempItem: {},
      importFn: importCustomDevice,
      exportFn: exportCustomDeviceTemplate,
      imgListMap: {},
      getDeviceImg
    }
  },
  watch: {
    customerId(val) {
      this.reast()
      if (!val) {
        return
      }
      csp.getCustomer(val).then((res) => {
        this.customer = res
      })
      this.getCustomDevice(val);
      this.getDeviceTypeList();
      this.filter = {
        customerId: this.customerId,
        isAssigned: true,
        assemblyState: '',
        deviceTypeId: ''
      }
      this.deviceTypeCode = 0
      this.deviceStatus = '0'
      this.getCustomerMachineList()
      this.getDeviceImgDic()
    },
    deep: true,
    immediate: true,
  },
  methods: {
    getDeviceImgDic() {
      this.imgListMap= {}
      dictBizServiceProxy.dictionary('device_image').then(res => {
        if (res.data && res.data.length > 0) {
          res.data.forEach(re => {
            this.imgListMap[re.dictValue] = re.dictKey
          })
        }
      })
    },
    showCreateDevice() {
      // 新建自定义设备
      this.customDeviceDialog = true;
      this.customDeviceItem = {
        id: '',
        deviceName: '',
        deviceCode: '',
        deviceTypeId: '',
        deliveryTime: null,
        customerId: ''
      }
    },
    getCustomDevice(customerId){
      // 自定义设备获取
      cmps.page(1, {customerId}, 100).then(res=>{
        this.customDeviceList = res.records;
      });
    },
    editCustomDevice(item){
      item.deliveryTime = item.deliveryTime ? moment(new Date(item.deliveryTime)) : null
      this.customDeviceItem = item;
      this.customDeviceDialog = true;
    },
    getDeviceTypeList(){
      // 设备类型
      dtsp.pageDeviceType({keyWord:'',query: {current:1, size: -1}}).then(res=>{
        this.deviceTypeList= res.records;
      })
    },
    customDeviceCancel(){
      this.customDeviceDialog= false;
    },
    createCustomerDevice(item) {
        cmps.submit(item).then(_=>{
        this.$message.success(this.$t('page_resource_pool_success'))
        this.customDeviceDialog= false;
        this.getCustomDevice(this.filter.customerId);
      })
    },
    updateCustomDevice(item){
      item.customerId = item.id? item.customerId : this.filter.customerId;
      item.deliveryTime = item.deliveryTime ? dayjs(item.deliveryTime).format('YYYY-MM-DD HH:mm:ss') : null;
      cmps.checkMachine(item).then(res => {
        // 正常状态
        if (res.status === 0) {
          this.createCustomerDevice(item)
        } else if (res.status === 1) {
          Modal.error({
          title: this.$t('tips'),
          content: '当前客户下已存在相同序列号的系统设备或自定义设备',
          okText: this.$t('ok'),
          centered: true
         });
        } else if (res.status === 2) {
          this.tempItem = item
          this.visible = true
          this.showTip = res.notOutbound
          this.customerList = res.customerList
        }
      })

    },
    toggleCustomer(id) {
      this.visible = false
      this.customDeviceDialog= false;
      this.$emit('toggleCustomer', id)
    },
    customerDeviceOk() {
      this.visible = false
    },
    deleteCustomDevice(item){
      this.$confirm({
        title: this.$t('delete'),
        content:  this.$t('page_ops_delete_custom_device_tip'),
        okText: this.$t('delete'),
        okType: 'danger',
        cancelText: this.$t('cancel'),
        icon: () => <a-icon style="color: #ff0000" type="exclamation-circle" />,
        onOk: () => {
          cmps.deleteMachineList([item.id]).then(_=>{
            this.$message.success(this.$t('delete_success'))
            this.getCustomDevice(this.filter.customerId)
          })
        }
      })
    },
        // 打开二维码
    openQrcode() {
      if (typeof this.customerId === 'undefined') {
        return
      }
      const weChatAppletMap = {
        'masterlink': 'cloud-7gcft4p72daa8f48-1313341508.tcloudbaseapp.com', 
        'makino': 'cloud-6go60bz547dfafad-1308944524.tcloudbaseapp.com'
      }
      const type = window.location.href.includes('makino.cloud') ? 'makino' : 'masterlink';
      window.open(
        `https://cli.im/api/qrcode/code?text=https://${weChatAppletMap[type]}?customerId=${this.customerId}&mhid=thfDDlzvyMwhMHcpLNdcO64`
      )
    },
    reast() {
      this.customer = {}
      this.machineList = []
      this.currentMachine = {}
      this.deviceTypeCode = 0
      this.deviceStatus = '0'
      this.filter = {
        customerId: '',
        isAssigned: true,
        assemblyState: '',
        deviceTypeId: ''
      }
      this.statusData = {}
      this.moveVisible = false
      this.moveLoading = false
    },
    handleMove() {
      this.moveVisible = true
    },
    moveCancel() {
      this.moveVisible = false
    },
    async moveOk(value, unValue) {
      this.moveVisible = false
      const input = {
        targetTenantId: this.customer.relatedTenantId,
        workStationIdList: value,
        unsharedWorkStationIdList: unValue
      }
      await msp.shareMachine(input)
      this.getCustomerMachineList()
    },
    async changeMachine(machine) {
      this.currentMachine = machine
      this.refreshStatus()
    },
    async refreshStatus() {
      if (this.currentMachine && this.currentMachine.id) {
        const work = {
          key: this.currentMachine.id,
          name: this.currentMachine.name
        }
        const data = {
          date: dayjs().format('YYYY-MM-DD'),
          workStationList: [work]
        }
        const values = await stsp.statusRecord(data)
        this.statusData = values
      }
    },
    async getCustomerMachineList() {
      this.machineList = []
      this.statusData = {}
      this.currentMachine = {}
      this.machineList = await this.getMachineList()
      if (this.machineList && this.machineList.length) {
        this.changeMachine(this.machineList[0])
      }
    },
    async getMachineList() {
      return await (await msp.getMachineList(1, this.filter, -1)).records
    },
    handleChange(value) {
      this.deviceTypeCode = value
      this.filter.deviceTypeId = value !== 0 ? value : ''
      this.getCustomerMachineList()
    },
    handleChangeStatus(value) {
      this.deviceStatus = value
      this.filter.assemblyState = value !== '0' ? value : ''
      this.getCustomerMachineList()
    }
  }
}
</script>

<style lang="less" scoped>
.customer-info-content {
  height: 100%;
  .name {
    color: #5395ca;
    font-size: 16px;
    font-weight: 500;
    line-height: 18px;
    border-left: 3px solid #5395ca;
    padding-left: 10px;
    margin: 8px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .customer-info-qr {
      color: #49d1d1;
      cursor: pointer;
      font-size: 14px;
    }
  }
}
.customer-info {
  border-top: 4px solid #5395ca;
  background: #fff;
  padding: 4px 8px;
  border-bottom: 1px solid #d7d7d7;

  
  .customer-info-detail {
    padding: 10px;
  }
}

.customDetail-select-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 8px;
}

.footer-wapper {
  background: #fff;
  padding: 8px;
  height: calc(100% - 68px);

  .left-wapper {
    width: 412px;

    .title-wapper {
      display: flex;
      justify-content: space-between;
    }
  }
}

.scroll-panel {
  height: 100%;
  padding: 8px 8px 8px 0;
  .scroll {
    overflow: auto;
    height: calc((100% - 150px)/2);
  }

  .list-panel {
    width: 100%;
    overflow: auto;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    border: 1px solid #d7d7d7;
    padding: 4px;

    .panel-wapper {
      margin: 4px;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      width: 118px;
      padding: 5px 0;
      color: #999999;

      &:hover {
        cursor: pointer;
      }

      &.selected {
        background-color: #fff1b8;
        color: rgba(0, 0, 0, 0.45);
        .name {
          color: #000;
        }
      }

      .pic {
        text-align: center;
        position: relative;
        padding: 0 20px 6px;
      }

      img {
        width: 67px;
        height: 69px;
      }

      .name {
        font-size: 14px;
        max-width: 70px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        color: #000;
      }
      .code {
        font-size: 13px;
        max-width: 70px;
        height: 20px;
        line-height: 20px;
        text-align: center;
      }

      .flag {
        position: absolute;
        top: 4px;
        left: 4px;
        padding: 1px 4px;
        line-height: 16px;
        box-sizing: border-box;
        background-color: #2a3f4e;
        border-radius: 2px;
        border: solid 1px rgba(126, 207, 239, 0.4);
        color: #7ecfef;
        font-size: 10px;
        text-align: center;
        z-index: 2;

        &.err {
          color: #ef7e7e;
          border-color: #ef7e7e;
          background-color: #40323b;
        }
      }
    }
  }
}
/deep/ .ant-tabs .ant-tabs-top-content,
/deep/ .ant-tabs .ant-tabs-bottom-content {
  width: 100%;
  height: calc(100% - 70px);
}
.tag {
  padding: 2px 8px;
  border: 1px solid #b7eb8f;
  position: absolute;
  right: 4px;
  top: 4px;
  font-weight: bold;
  z-index: 1;
  border-radius: 3px;
  background-color: #f6ffed;
  color: #b7eb8f;
}
/deep/.ant-modal-header, /deep/.ant-modal-footer{
  border: none;
}
</style>
